import api from "../../client";
import { UpdateLinkTagsPayload } from "../../types/people";
import { Status } from "../../types/status";

export const updateLinkTagsRequest = async (
  id: string,
  payload: UpdateLinkTagsPayload,
): Promise<Status> => {
  const { data } = await api.put<Status>(`/link/${id}/tags`, payload);

  return data;
};
